import React from 'react';

export const Divider: React.FC = () => {
  return <div className="my-8 border-t border-gray-200" />;
};